import type { ReactNode } from 'react'

type Tone = 'neutral' | 'ok' | 'warn' | 'err' | 'info' | 'read' | 'write' | 'execute'

interface Props {
  tone?: Tone
  children: ReactNode
}

const COLORS: Record<Tone, { fg: string; bg: string }> = {
  neutral: { fg: 'var(--fg-2)', bg: 'var(--bg-subtle)' },
  ok:      { fg: 'var(--ok)',  bg: 'var(--ok-bg)' },
  warn:    { fg: 'var(--warn)', bg: 'var(--warn-bg)' },
  err:     { fg: 'var(--err)',  bg: 'var(--err-bg)' },
  info:    { fg: 'var(--info)', bg: 'var(--info-bg)' },
  read:    { fg: 'var(--scope-read)',  bg: 'var(--scope-read-bg)' },
  write:   { fg: 'var(--scope-write)', bg: 'var(--scope-write-bg)' },
  execute: { fg: 'var(--scope-exec)',  bg: 'var(--scope-exec-bg)' },
}

export function Badge({ tone = 'neutral', children }: Props) {
  const c = COLORS[tone]
  return <span className="badge" style={{ color: c.fg, background: c.bg }}>{children}</span>
}
